import * as types from './types'
import storage from '@/plugins/storage'
import store from '@/store'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.BRANDS_DAYS, days)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.BRANDS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.BRANDS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.BRANDS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.BRANDS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.BRANDS_FILTER_BY, filterBy)
  },
  [types.SET_BRANDS](state, data) {
    state.brands = []
    if (data !== undefined && data !== null) {
      state.brands = data
    }
  },
  [types.SET_BRAND](state, data) {
    state.brand = null
    if (data !== undefined && data !== null) {
      state.brand = data
    }
  },
  [types.SET_FRANCHISEES](state, data) {
    state.franchisees = []
    if (data !== undefined && data !== null) {
      state.franchisees = data
      if (data.length > 0) {
        store.dispatch('dispatch/setCenter', data[0].Firm)
      }
    }
  },
  [types.SET_SHOPS](state, data) {
    state.shops = null
    if (data !== undefined && data !== null) {
      state.shops = data
    }
  },
  [types.RESET_PREFERENCES](state) {
    state.preferences = []
  },
  [types.SET_PREFERENCE](state, data) {
    state.preferences.forEach(element => {
      if (element.name === data.name && element.type === data.type) {
        element.brand = data.brand
        if (data.isInactive !== undefined && data.isInactive !== null) {
          element.isInactive = data.isInactive
        } else {
          element.value = data.value
        }
        element.changed = true
      }
    })
  },
  [types.RESET_PREFERENCE_CHANGE](state, element) {
    if (state.preferences !== undefined && state.preferences !== null) {
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          state.preferences[i].changed = false
        }
      }
    }
  },
  [types.UPDATE_PREFERENCE](state, data) {
    if (state.preferences.length === 0) {
      state.preferences = []
    }
    if (state.preferences !== undefined && state.preferences !== null) {
      let found = false
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          if (
            state.preferences[i].type === data.type &&
            parseInt(state.preferences[i].firm) === parseInt(data.firm)
          ) {
            if (state.preferences[i].name === data.name) {
              if (data.isInactive !== undefined && data.isInactive !== null) {
                state.preferences[i].isInactive = data.isInactive
              } else {
                state.preferences[i].value = data.value
              }
              state.preferences[i].changed = true
              found = true
              break
            }
          }
        }
      }
      if (found === false) {
        data.changed = true
        state.preferences.push(data)
      }
    }
  },
  [types.SET_PREFERENCES](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        data.forEach(element => {
          element.changed = false
          let found = false
          for (var i = 0; i < state.preferences.length; i++) {
            if (
              state.preferences[i].name === element.name &&
              state.preferences[i].type === element.type
            ) {
              found = true
              break
            }
          }
          if (!found) {
            state.preferences.push(element)
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/brands/mutations.js